export default __webpack_public_path__ + "images/cx-logo-new.png";